export function toggleSplashState() {
  const splashElement = document.querySelector(".splash");

  if (splashElement) {
    splashElement.classList.toggle("active");
  }
}
